// Core imports
import { Button, Result, Spin } from 'antd';
import React, { Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';

// Component imports
import NdeEditForm from '../components/NDEs/NdeEditForm';
import { NAV_NOT_FOUND, NAV_ROOT, SUPPORT_EMAIL } from '../constants';
import { clearNdes, fetchNdeByUuid } from '../store/ndes/ndesThunks';

// Asset imports
import NotFoundIcon from '../assets/images/not-found.png';

const NdeEditScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { ndeUuid } = useParams();

  const { nde, isFetchingNde, fetchNdeError } = useSelector((state) => state.ndes);

  useEffect(() => {
    if (!ndeUuid) {
      return navigate(NAV_NOT_FOUND, { replace: true });
    }

    dispatch(fetchNdeByUuid(ndeUuid));

    // Cleanup
    return () => {
      dispatch(clearNdes());
    };
  }, []);

  return (
    <Fragment>
      {
        isFetchingNde ? (
          <Spin />
        ) : nde ? (
          <NdeEditForm initialValues={nde} />
        ) : fetchNdeError ? (
          <Result
            className="mb-64"
            icon={<img src={NotFoundIcon} alt="Not found" style={{ maxHeight: 400 }} />}
            title={t('NDE Not Found', { context: 'Title' })}
            subTitle={
              <>
                {t('Sorry, this NDE could not be found or you may not have permission to edit it.', { context: 'Message' })}
                {SUPPORT_EMAIL && (
                  <>
                    <br />
                    {' '}{t('If you need help, please contact us at', { context: 'Support prompt' })}{' '}
                    <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
                  </>
                )}
              </>
            }
            extra={
              <Link to={NAV_ROOT}>
                <Button type="primary" className="bg-black-100 border-color-black-100 hover-bg-black-80 hover-border-color-black-80">
                  {t('Return Home', { context: 'Call to action' })}
                </Button>
              </Link>
            }
          />
        ) : null
      }
    </Fragment>
  );
};

export default NdeEditScreen;
